<template>
  <div class="animation-puzzle">
    <div class="col-puzzle left">
        <img  src="../assets/bg-animations/puzzle/fila-1-puzzle-1.png" />
        <img  src="../assets/bg-animations/puzzle/fila-1-puzzle-2.png" />
        <img  src="../assets/bg-animations/puzzle/fila-1-puzzle-3.png" />
    </div>
    <div class="col-puzzle right">
      <img  src="../assets/bg-animations/puzzle/fila-2-puzzle-1.png" />
      <img  src="../assets/bg-animations/puzzle/fila-2-puzzle-2.png" />
      <img  src="../assets/bg-animations/puzzle/fila-2-puzzle-3.png" />
    </div>
  </div>
</template>

<script>

import {gsap} from 'gsap'

export default {
  name: 'PuzzleAnimation',
  props: ['start'],
  components:{
  },
  data(){
    return {

    }
  },
  methods:{
    startTransition(){
      
      var TL = gsap.timeline({delay: 1})
      TL
      .to('.col-puzzle img',{opacity: 1, rotation: "random(-35, 35)", stagger: 0.1, duration: 1})
      .to('.col-puzzle img',{opacity: 0, stagger: 0.1, duration: 1}, '+=2')
    }
  },
  mounted(){
    
  },
  computed:{
   
  },
  watch: {
    start(){
      this.startTransition()
    }
  }
}
</script>

<style lang="scss">
  .animation-puzzle {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .col-puzzle{
      position: relative;
      width: 30%;
      height: 80%;
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      img{
        width: 40%;
        opacity: 0;
      }
      &.left{
        img{
          margin: 0;
          &:nth-child(2){
            margin: 0 auto;
          }
        }
      }
      &.right{
        img{
          margin-left: auto;
          margin-right: 0;
          &:nth-child(2){
            margin: 0 auto;
          }
        }
        @media screen and (max-width: 768px) {
          display: none;
        }
      }
      @media screen and (max-width: 768px) {
        width: 60%;
      }
    }
  }
</style>